export function getStatusInitials(text: string) {
  const words = text.trim().split(' ')

  if (words.length >= 2) {
    // If has two or more words, get the initial of each word
    return (words[0][0] + words[1][0]).toUpperCase()
  } else {
    // If single word, get the first two letters
    return text.slice(0, 2).toUpperCase()
  }
}
